<template>
  <div class="row bg-origami pb-xl">
    <HomepageSection :title="`Plans starting from ${plans.capsule.basePrice}`">
      <div class="d-flex flex-column flex-md-row w-100 justify-content-center pb-md">
        <div
          v-for="benefit in benefits"
          :key="benefit"
          class="w-100 d-flex flex-column justify-content-center align-items-center gap-sm">
          <svg-check-outline class="plan-check"/>
          <h3>{{ benefit }}</h3>
        </div>
      </div>
      <GetStartedButton
        location="plans"
        class="fixed-width"/>
    </HomepageSection>
  </div>
</template>

<script setup>

import SvgCheckOutline from '@/homepage/components/svg/SvgCheckOutline.vue'
import GetStartedButton from '@/homepage/components/GetStartedButton.vue'
import HomepageSection from '@/homepage/components/HomepageSection.vue'

const plans = window.armoire.plans
const benefits = [
  'Free Shipping',
  'Free Cleaning',
  'Free Styling'
]
</script>

<style lang="scss" scoped>

</style>
